<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
<div class="dashboard-container">
<app-admin-nav></app-admin-nav>

<div id="order">
    <div class="w-100 box order-header">
        <div class="d-flex flex-column gap-2">
            <span class="orderNo">{{ 'order_details_order_no' | translate: { orderNo: order?.orderNo } }}</span>
            <span class="muted-header">{{ 'order_details_timestamps' | translate: {
                created: (order?.createdAt | customDate), updated: (order?.updatedAt | customDate) } }}</span>
        </div>
        <div class="header-meta">
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">{{ 'orders_table_date' | translate }}</span>
                <span class="value">{{ order?.createdAt | customDate }}</span>
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">{{ 'orders_table_assigned_to' | translate }}</span>
                @if (!order?.assignedTo) {
                    <!-- The label stays in the DOM while taking, hidden, so the button
                         keeps its width; the spinner sits over it. -->
                    <button class="primary-btn take-btn" [disabled]="takingOrder"
                        [class.is-taking]="takingOrder" (click)="takeOrder(order)">
                        <span class="take-btn-label">{{ 'orders_action_take' | translate }}</span>
                        @if (takingOrder) {
                            <span class="take-btn-spinner" aria-hidden="true"></span>
                        }
                    </button>
                }
                @if (order?.assignedTo) { <span class="value">{{ order.assignedTo }}</span>}
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">{{ 'orders_table_status' | translate }}</span>
                <!-- Unassigned orders show the status as plain text: it stays on
                     'New' until someone takes the order. -->
                @if (order?.assignedTo) {
                    <!-- [ngModel] + (ngModelChange) rather than banana-in-a-box: the
                         handler rolls the selection back if the save fails. -->
                    <ng-select #statusSelect class="fyes-select status-select" [items]="statuses" bindLabel="title"
                        bindValue="id"
                        [ngModel]="statusId" (ngModelChange)="onStatusChange($event)" [clearable]="false"
                        [searchable]="false" [disabled]="savingStatus">
                    </ng-select>
                } @else {
                    <span class="value" [ngbTooltip]="'order_details_status_locked' | translate"
                        container="body">{{ currentStatusTitle }}</span>
                }
            </div>
        </div>
    </div>
    <div class="order-columns">
        <div class="d-flex flex-column flex-grow-1 gap-3">
            <div class="box order-details">
                <span class="header">{{ 'order_details_contact_details' | translate }}</span>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">{{ 'field_email' | translate }}</span>
                    <span class="value">{{ order?.contactDetails.email }}</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">{{ 'order_details_phone' | translate }}</span>
                    <span class="value">{{ order?.contactDetails.phone }}</span>
                </div>
            </div>
            <div class="box order-details">
                <span class="header">{{ 'order_details_title' | translate }}</span>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">{{ 'order_details_space_type' | translate }}</span>
                    <span class="value">{{ order?.spaceType }}</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">{{ 'order_details_size' | translate }}</span>
                    <span class="value">{{ order?.size }} {{ 'order_details_size_unit' | translate }}</span>
                </div>
                <!-- One row per question the space type asked, snapshotted onto
                     the order at creation so a later edit to the field
                     definitions cannot change what a past order says. -->
                @for (row of order?.spaceDetailsSummary; track row.key) {
                <div class="d-flex flex-column gap-2">
                    <!-- Rendered as stored: a free-text answer is already
                         filed as "Description" on the order, so there is no
                         per-field special case here. -->
                    <span class="muted-header">{{ row.label }}</span>
                    <!-- Free text can run to 500 characters and needs a readable
                         line-height, unlike the counts. -->
                    <span class="value" [class.long-value]="row.input === 'text'">{{ row.value }}</span>
                </div>
                }
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">{{ 'order_details_automations' | translate }}</span>
                    <div class="d-flex gap-2 flex-wrap">
                        @for (automation of order?.automations; track $index) {
                        <div class="pill">
                            <span>{{automation.title}}</span>
                        </div>
                        }
                    </div>
                </div>
                <div class="price-area">
                    <div class="price-details">
                        <div class="d-flex justify-content-between gap-5">
                            <span class="muted-header">{{ 'order_details_item_subtotal' | translate }}</span>
                            <span class="muted-header">{{ order?.totalPrice }}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="muted-header">{{ 'order_details_discount' | translate }}</span>
                            <span class="muted-header">0</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="value">{{ 'order_details_order_total' | translate }}</span>
                            <span class="value">{{ order?.totalPrice }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="comment-box box order-details">
            <span class="header">{{ 'order_details_comments' | translate }}</span>
            @for (comment of order?.comments; track $index) {
            <div class="comment">
                <span class="text" style="color: #FFFFFF;">{{ comment.comment }}</span>
                <span class="muted-text">{{ comment.date | customDate }}</span>
                <span class="muted-text">{{ 'order_details_comment_by' | translate: { name: comment.commentedBy } }}</span>
            </div>
            }
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">{{ 'order_details_add_note' | translate }}</span>
                <textarea rows="4" class="fyes-input" [placeholder]="'order_details_note_placeholder' | translate"
                    [(ngModel)]="newComment" (keydown.enter)="onEnterPress($event)"></textarea>
            </div>
        </div>
    </div>
</div>
</div>
</div>

<app-footer></app-footer>